import React, { useEffect, useState } from "react";
import { Loader } from "@scuf/common";
import { useSelector } from "react-redux";
import { Checkbox, TextArea, Modal, Badge, Icon } from "@scuf/common";
import {
  ERROR_MSG_FOR_USER_RESPONSE,
  HAS_SCRIPT,
  ACTION_UPLOAD_TYPE,
  FILE_UPLOAD_WARNING,
  ACTION_ALREADY_COMPLETED_UPLOAD_TEXT,
  CHECKLIST_UPLOAD_TYPE,
} from "../../../../../constants/constants";
import { IUserResponseModel } from "../../../../../models/IOpportunitiesAPIModel";
import { getReasons } from "../../../../../services/Opportunities";
import { getReviewerUploadedFiles } from "../uploadedFiles";
import { AttachmentDownload } from "../../AttachmentDownload";
import { FileUpload } from "../../../../UploadFileModal/FileUpload";
import { ActionTracking } from "../../../../ActionTracking/ActionTracking";
import { USER_ROLE } from "../../../../../constants/constants";
import { getIsActionAlreadyCompleted } from "src/slices/actionTrackingSlice";
import { getCurrentRole } from "src/slices/onBoardingSlice";
import { Radio } from "@scuf/common";
import "../ReviewerCheckList.scss";
import "./RadioActionStatus.scss";
const RadioActionStatus = (props: any) => {
  const [actionResponseStatus, setActionResponseStatus] = useState("null");
  const [enableRetryErr, setEnableRetryErr] = useState(false); // flag to enable submit button
  const [btnText, setBtnText] = useState("Submit");
  const [remark, setRemark] = useState("");
  const [showLableBardge, setShowLableBardge] = useState(false);
  const [submitBtnDisable, setSubmitBtnDisable] = useState(true);
  const [acceptReason, setAcceptReason] = useState([] as any);
  const [selctedPolicy, setselctedPolicy] = useState([] as any); // flag to enable submit button
  const [selctedDesStatus, setselctedDesStatus] = useState<boolean[]>([]);
  const [refresh, setRefresh] = useState(false);
  const [reasonLoading, setReasonLoading] = useState(true);
  const [reasonError, setReasonError] = useState(false);
  const [showRemarkError, setShowRemarkError] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<{ activityId: number; fileName: string; storedFileName?: string }[]>([]);
  const [uploadedFilesError, setUploadedFilesError] = useState(false);
  const [emailItemData, setEmailItemData] = useState([] as any);
  const [shareToAction, setShareToAction] = useState([] as any);
  const [actionComplete, setActionCompete] = useState(false);
  const currentRole = useSelector(getCurrentRole);
  const [textBoxValue, setTextBoxValue] = useState("");
  const [reviewerCheckListResponse, setReviewerCheckListResponse] = useState(
    [] as any
  );
  const isActionAlreadyCompleted = useSelector(getIsActionAlreadyCompleted);
  const [showModal, setShowModal] = useState("");
  const trainingRequiredActionType = props.trainingRequiredActionType ?? "acceptanddropdown";
  const actionOwnerRequiredActionType = props.actionOwnerRequiredActionType ?? "acceptwithproposedactionowner";
  const isActionProposalFlow = props.isTrackingFlow && actionResponseStatus === "Action Required";
  const uploadType = isActionProposalFlow || actionResponseStatus === "No Action Required"
    ? CHECKLIST_UPLOAD_TYPE
    : ACTION_UPLOAD_TYPE;
  const requiredFileLabel = uploadedFilesError || props.isEvidenceError
    ? "Supporting file required; saved files could not be verified"
    : "Supporting file required";

  useEffect(() => {
    let active = true;
    setUploadedFiles([]);
    setUploadedFilesError(false);
    getReviewerUploadedFiles(props.opportunityId)
      .then(response => {
        if (active) {
          setUploadedFiles(response.activity
            .filter(activity =>
              (activity.type === ACTION_UPLOAD_TYPE || activity.type === CHECKLIST_UPLOAD_TYPE) &&
              typeof activity.file_details?.file_name === "string"
            )
            .map(activity => ({
              activityId: activity.activity_id,
              fileName: activity.file_details.file_name,
              storedFileName: activity.file_details.stored_file_name
            })));
        }
      })
      .catch(() => {
        if (active) {
          setUploadedFilesError(true);
        }
      });
    return () => { active = false; };
  }, [props.opportunityId, isUploaded]);

  const uploadedFilesList = (
    <>
      {uploadedFiles.length > 0 && (
        <div className="file-value-wrapper old-files-wrapper">
          {uploadedFiles.map(file => (
            <span className="file-value-wrapper-content" key={file.activityId} title={file.fileName}>
              <Icon name="document-report" root="common" size="small" className="file-value-icon" />
              <div className="file-value-wrapper-content-data">{file.fileName}</div>
              <AttachmentDownload opportunityId={props.opportunityId} fileName={file.fileName} storedFileName={file.storedFileName} />
            </span>
          ))}
        </div>
      )}
    </>
  );

  const getCheckedActionReasons = () => acceptReason.filter((item: any) => item.checked === true);

  // Reuses Org Owner's ActionTracking/EmailTargetComponent row model (reason_id, reason, data: [{action_owner_id, target_date, remarks, training_name, isValid}])
  const onAddedActionEmail = (shareToElementValue: any, isValidActionReasonStatus: boolean) => {
    setShareToAction((prev: any) => {
      const existingIndex = prev.findIndex((item: any) => item.reason_id === shareToElementValue.reason_id);
      if (existingIndex >= 0) {
        const next = [...prev];
        next[existingIndex] = { ...shareToElementValue, isValid: isValidActionReasonStatus };
        return next;
      }
      return [...prev, { ...shareToElementValue, isValid: isValidActionReasonStatus }];
    });
  };

  const isTrackingMandatoryIncomplete = () => {
    if (!isActionProposalFlow) {
      return false;
    }
    const checkedReasons = getCheckedActionReasons();
    if (checkedReasons.length === 0) {
      return false;
    }
    return checkedReasons.some((item: any) => {
      const entry = shareToAction.find((shareTo: any) => shareTo.reason_id === item.reason_id);
      return !entry || entry.isValid === false;
    });
  };

  // flag to enable submit button
  useEffect(() => {
    setSubmitBtnDisable(true);

    setReasonError(false);
    let data: any = {
      current_role: currentRole,
      user_response: "",
      kpi_id: props.kpiId,
      remarks: "",
      // reason: feedback,
    };
    if (actionResponseStatus === "No Action Required") {
      setShowModal("reason");
      setReasonLoading(true);
      setselctedDesStatus([]);
      setShowLableBardge(true);
      setselctedPolicy([]);
      setRemark("");

      const feedback = selctedPolicy.toString();
      data = {
        current_role: currentRole,
        user_response: actionResponseStatus,
        kpi_id: props.kpiId,
        remarks: "",
        reason: "",
        orguser_id: props.orguserId,
        anomaly_id: props.anomalyId,
      };
      props.handleRadio(data, props.labelId);
      props.handleCheckboxData(
        true,
        props.labelId,
        "radio",
        props.isMandatory,
        actionResponseStatus
      );

      getReasons(props.opportunityId, "reject")
        .then((response) => {
          setReasonLoading(false);
          setAcceptReason(response);
        })
        .catch(() => {
          setReasonLoading(false);
          setReasonError(true);
        });
    } else if (actionResponseStatus === "Action Required") {
      setselctedPolicy([]);
      setShowModal("reason");
      setReasonLoading(true);
      const feedback = selctedPolicy.toString();

      data = {
        current_role: currentRole,
        user_response: actionResponseStatus,
        kpi_id: props.kpiId,
        remarks: "",
        reason: "",
        orguser_id: props.orguserId,
        anomaly_id: props.anomalyId,
      };
      props.handleRadio(data, props.labelId);
      setShowLableBardge(false);
      setRemark("");
      setselctedDesStatus([]);
      props.handleCheckboxData(
        true,
        props.labelId,
        "radio",
        props.isMandatory,
        actionResponseStatus
      );

      Promise.all([
        getReasons(props.opportunityId, "accept"),
        getReasons(props.opportunityId, trainingRequiredActionType),
        getReasons(props.opportunityId, actionOwnerRequiredActionType)
      ])
        .then(([acceptReasons, trainingReasons, actionOwnerReasons]) => {
          setReasonLoading(false);
          setAcceptReason([...acceptReasons, ...trainingReasons, ...actionOwnerReasons]);
        })
        .catch(() => {
          setReasonLoading(false);
          setReasonError(true);
        });
    } else if (
      actionResponseStatus !== "null" &&
      props.action_for.includes(actionResponseStatus) === true
    ) {
      // else if(actionResponseStatus === "No" || actionResponseStatus === "May Be"){
      setShowModal("text");
      data = {
        current_role: currentRole,
        user_response: actionResponseStatus,
        kpi_id: props.kpiId,
        remarks: props.remarks,
        reason: "",
        orguser_id: props.orguserId,
        anomaly_id: props.anomalyId,
      };
      props.handleRadio(data, props.labelId);
      props.remarks !== "" && props.remarks !== "null"
        ? props.handleCheckboxData(
            false,
            props.labelId,
            "radio",
            props.isMandatory,
            actionResponseStatus
          )
        : props.handleCheckboxData(
            true,
            props.labelId,
            "radio",
            props.isMandatory,
            actionResponseStatus
          );
    } else if (
      actionResponseStatus !== "null" &&
      props.action_for.includes(actionResponseStatus) === false
    ) {
      setShowModal("");
      data = {
        current_role: currentRole,
        user_response: actionResponseStatus,
        kpi_id: props.kpiId,
        remarks: props.remarks,
        reason: "",
        orguser_id: props.orguserId,
        anomaly_id: props.anomalyId,
      };
      props.handleRadio(data, props.labelId);
      props.handleCheckboxData(
        false,
        props.labelId,
        "radio",
        props.isMandatory,
        actionResponseStatus
      );
    }
  }, [actionResponseStatus]);

  useEffect(() => {
    if (
      props.activityDetails != undefined &&
      props.activityDetails.length > 0
    ) {
      if (props.activityDetails[0].action_details.user_response == "accept") {
        const reasons = props.activityDetails[0].action_details.reason;
        let reasonArray = reasons.split(",");
        setselctedPolicy(reasonArray);
        const reviewerRemark = props.activityDetails[0].action_details.remarks;
        setRemark(reviewerRemark);
        setselctedPolicy(reasonArray);
        if (acceptReason.length > 0) {
          acceptReason.forEach((element: any) => {
            element.checked = false;
          });
          reasonArray.map((reasonValue: string) => {
            let objIndex = acceptReason.findIndex(
              (obj: any) => obj.title == reasonValue
            );
            if (objIndex >= 0) {
              acceptReason[objIndex].checked = true;
            }
          });
          let checkedArray = acceptReason.filter(
            (data: any) => data.checked == true
          );
          setAcceptReason(acceptReason);
          let requireRemarkArray: any = [];
          for (let i = 0; i < checkedArray.length; i++) {
            requireRemarkArray.push(checkedArray[i].requires_remarks);
          }
          setselctedDesStatus(requireRemarkArray);
          setRefresh(!refresh);
          setReasonLoading(false);
        }
      }
    }
  }, [acceptReason.length]);

  useEffect(() => {
    if (shareToAction.length > 0) {
      let actionIncomplete = shareToAction.filter((item: any) => {
        return item.isValid === false;
      });
      if (actionIncomplete.length === 0) {
        setActionCompete(true);
      } else {
        setActionCompete(false);
      }
    }
  }, [actionComplete, shareToAction]);

  const setRemarkHandleChange = (e: string) => {
    let inValidCharacter = /[<>()&#]/;
    if (!inValidCharacter.test(e)) {
      setShowRemarkError(false);
      setRemark(e.trimStart());
      setRefresh(!refresh);
      if (e.trimStart() === "") {
        let result = selctedDesStatus.filter((item) => item === true);
        if (result.length == 0) {
          setSubmitBtnDisable(true);
          // setRefresh(!refresh);
        }
        if (result.length > 0) {
          setSubmitBtnDisable(true);
          setRefresh(!refresh);
        }
      }
      if (e.trimStart() != "") {
        let result = selctedDesStatus.filter((item) => item === true);
        if (result.length == 0 && acceptReason.length == 0) {
          setSubmitBtnDisable(false);
        }
        if (result.length > 0) {
          setSubmitBtnDisable(false);
        }
      }
    } else {
      setShowRemarkError(true);
    }
  };

  const handleCheckbox = (
    id: number,
    check: boolean,
    name: string,
    Des: boolean
  ) => {
    const nextSelectedPolicy = check
      ? selctedPolicy.filter((policy: string) => policy !== name)
      : [...selctedPolicy, name];

    const nextSelectedDesStatus = [...selctedDesStatus];
    if (check === true) {
      const descIndex = nextSelectedDesStatus.indexOf(Des);
      if (descIndex > -1) {
        nextSelectedDesStatus.splice(descIndex, 1);
      }
    } else {
      nextSelectedDesStatus.push(Des);
    }

    setselctedPolicy(nextSelectedPolicy);
    setselctedDesStatus(nextSelectedDesStatus);

    let showBardge = nextSelectedDesStatus.filter((item) => item === true);
    if (showBardge.length >= 1) {
      if (remark === "") {
        setShowLableBardge(true);
        setSubmitBtnDisable(true);
      }
      if (remark.length > 0) {
        setShowLableBardge(false);
        setSubmitBtnDisable(false);
      }
    } else if (nextSelectedDesStatus.length === 0) {
      setSubmitBtnDisable(true);
      setShowLableBardge(true);
    } else {
      setShowLableBardge(false);
      setSubmitBtnDisable(false);
    }
    let newState = acceptReason.map((item: any) =>
      item.reason_id === id ? { ...item, checked: check ? false : true } : item
    );
    setAcceptReason(newState);

    const data = {
      current_role: currentRole,
      user_response: actionResponseStatus,
      kpi_id: props.kpiId,
      remarks: remark,
      reason: nextSelectedPolicy.join(","),
      orguser_id: props.orguserId,
      anomaly_id: props.anomalyId,
    };
    props.handleRadio(data, props.labelId);

    let shareToActionValue = [...shareToAction];
    let newShareToActionValue = [];
    if (check === true) {
      newShareToActionValue = shareToActionValue.filter((item: any) => {
        return item.reason_id !== id;
      });
      setShareToAction(newShareToActionValue);
    }
  };

  const onAcceptClicked = () => {
    const feedback = selctedPolicy.toString();
    setSubmitBtnDisable(true);
    setEnableRetryErr(false);
    setBtnText("Submitting...");
    let inValidCharacter = /[<>()&#]/;
    let data: IUserResponseModel = {
      current_role: currentRole,
      user_response: "accept",
      kpi_id: props.kpiId,
      remarks: remark,
      reason: feedback,
    };
    if (props.role_name === "insight.org_user") {
      data = {
        current_role: currentRole,
        user_response: "accept",
        kpi_id: props.kpiId,
        remarks: remark,
        reason: feedback,
        accept_as_is: btnText === "Assign Action" ? true : false,
      };
    } else if (props.role_name === "insight.owner") {
      data = {
        current_role: currentRole,
        user_response: "accept",
        kpi_id: props.kpiId,
        remarks: remark,
        reason: feedback,
        orguser_id: props.orguserId,
        anomaly_id: props.anomalyId,
      };
    }
    if (!inValidCharacter.test(remark)) {
      if (props.role_name === USER_ROLE.REVIEWER) {
        props.sendUserResponse(data, emailItemData);
      }

      if (props.role_name === USER_ROLE.ORG_USER) {
        let errorScript = false;
        let shareToActionRemoveIsValidL1 = shareToAction.map(
          ({ isValid, ...rest }: any) => rest
        );
        var shareToActionRemoveIsValidL2: any = [];
        shareToActionRemoveIsValidL1.forEach((item: any) => {
          let newData: any = [];
          item.data.forEach((subItem: any) => {
            delete subItem.isValid;
            delete subItem.action_owner_email;
            delete subItem.createdOn;
            let modifyRecord = subItem;
            errorScript = inValidCharacter.test(subItem.remarks);
            if (errorScript) {
              setShowRemarkError(true);
              setBtnText(btnText);
            }
            newData.push(modifyRecord);
          });
          shareToActionRemoveIsValidL2.push({
            reason_id: item.reason_id,
            reason: item.reason,
            data: newData,
          });
        });
        data["share_to"] = shareToActionRemoveIsValidL2;
        // data["current_role"] =currentRole;
        if (!errorScript) {
          props.sendUserResponse(data, shareToActionRemoveIsValidL2);
        }
      }
    } else {
      setShowRemarkError(true);
      setBtnText("Submit");
    }
  };

  useEffect(() => {
    let disabled = handlesubmitDisabled();

    if (isUploaded === true) {
      disabled = true;
    }
    if (disabled === false) {
      let inValidCharacter = /[<>()&#]/;
      let data: any = {
        current_role: currentRole,
        user_response: "accept",
        kpi_id: props.kpiId,
        remarks: remark,
        // reason: feedback,
      };
      const feedback = selctedPolicy.toString();

      data = {
        current_role: currentRole,
        user_response: actionResponseStatus,
        kpi_id: props.kpiId,
        remarks: remark,
        reason: feedback,
        orguser_id: props.orguserId,
        anomaly_id: props.anomalyId,
      };

      props.handleRadio(data, props.labelId);
    }
    if (props.actionResponse !== "null" && props.actionResponse !== "") {
      if (
        (!props.actionResponse.includes("Action") &&
          props.remarks !== "" &&
          props.remarks !== "null") === true
      ) {
        props.handleCheckboxData(
          false,
          props.labelId,
          "radio",
          props.isMandatory,
          props.actionResponse
        );
      } else {
        props.handleCheckboxData(
          disabled,
          props.labelId,
          "radio",
          props.isMandatory,
          props.actionResponse
        );
      }
    } else {
      props.handleCheckboxData(
        disabled,
        props.labelId,
        "radio",
        props.isMandatory,
        props.actionResponse
      );
    }
  }, [
    submitBtnDisable,
    isUploaded,
    remark.trimStart(),
    shareToAction,
    isActionProposalFlow,
    acceptReason,
  ]);

  const handlesubmitDisabled = () => {
    if (props.role_name === USER_ROLE.REVIEWER) {
      if (isTrackingMandatoryIncomplete()) {
        return true;
      }

      return (submitBtnDisable && remark.trimStart() === "") ||
        isUploaded ||
        selctedPolicy.length == 0
        ? true
        : false;
    }
    return submitBtnDisable;
  };

  const handleActionResponse = (data: string) => {
    setActionResponseStatus(data);
  };

  const handleRemarkChange = (e: string) => {
    let inValidCharacter = /[<>()&#]/;
    if (!inValidCharacter.test(e)) {
      let data = {
        current_role: currentRole,
        user_response: actionResponseStatus,
        kpi_id: props.kpiId,
        remarks: e,
        reason: "",
        orguser_id: props.orguserId,
        anomaly_id: props.anomalyId,
      };
      props.handleRadio(data, props.labelId);
    } else {
      e = "";
    }
    e === ""
      ? props.handleCheckboxData(
          true,
          props.labelId,
          "radio",
          props.isMandatory,
          props.actionResponse
        )
      : props.handleCheckboxData(
          false,
          props.labelId,
          "radio",
          props.isMandatory,
          props.actionResponse
        );
  };

  useEffect(() => {
    setActionResponseStatus(props.actionResponse);
  }, [props.actionResponseStatus]);

  useEffect(() => {
    if (!props.onTrackingDataChange) {
      return;
    }
    const checkedReasons = getCheckedActionReasons();
    const checkedReasonIds = checkedReasons.map((item: any) => item.reason_id);
    const data = isActionProposalFlow
      ? shareToAction.filter((item: any) => checkedReasonIds.includes(item.reason_id))
      : [];
    props.onTrackingDataChange(data, !isTrackingMandatoryIncomplete());
  }, [isActionProposalFlow, acceptReason, shareToAction]);

  return (
    <div className="action-content">
      <div>
        {props.action.map((data: any) => (
          <Radio
            label={data}
            checked={actionResponseStatus === data}
            onChange={() => handleActionResponse(data)}
          />
        ))}
        {/* <Radio label="Action required" checked={"Action required" === actionResponseStatus} onChange={() => setActionResponseStatus("Action required")} />
        <Radio label="No Action required" checked={"No Action required" === actionResponseStatus} onChange={() => setActionResponseStatus("No Action required")} /> */}
      </div>
      {showModal === "reason" ? (
        <Modal.Content>
          <div>
            <div style={{ position: "relative" }} data-testid="getInvoiceCard">
              {reasonLoading && (
                <Loader
                  loading={reasonLoading}
                  text="Fetching reasons..."
                  minHeight="28vh"
                  max-height="70vh"
                  overlayColor="transparent"
                />
              )}

              {reasonError && (
                <div className="action--error-text">
                  {ERROR_MSG_FOR_USER_RESPONSE}
                </div>
              )}
              {!reasonLoading &&
                acceptReason.map((item: any, index: any) => (
                  <div key={item.reason_id}>
                    <Checkbox
                      className="checkbox-fi"
                      data-testid={`cb-reason1${index}`}
                      label={
                        item.desc !== null
                          ? `${item.title} ${item.desc}`
                          : `${item.title}`
                      }
                      checked={item.checked}
                      onChange={() => {
                        handleCheckbox(
                          item.reason_id,
                          item.checked,
                          item.title,
                          item.requires_remarks
                        );
                      }}
                    />
                    {isActionProposalFlow && item.checked && (
                      <ActionTracking
                        key={item.reason_id}
                        reasonId={item.reason_id}
                        reasonTitle={item.title}
                        actionType={item.action_type}
                        isChecked={item.checked}
                        isCommentRequired={item.requires_remarks}
                        onAddedActionEmail={onAddedActionEmail}
                        trainingOptions={item.action_type === trainingRequiredActionType ? props.trainingOptions : []}
                      />
                    )}
                  </div>
                ))}
            </div>
          </div>
          {true && (
            <>
              <label className="label">
                Remarks(Data saved on Submit only!){" "}
                {showLableBardge && remark === "" ? (
                  <Badge empty={true} color="red" />
                ) : (
                  ""
                )}
              </label>

              <TextArea
                onChange={setRemarkHandleChange}
                className="textarea-wrapper-comment"
                fluid={true}
                rows={1}
                placeholder={props.textAreaTitle}
                value={remark.trimStart()}
              />
            </>
          )}

          {/* <div className="warning-message">
            <Icon root="common" name="badge-warning" size="small" />
            <span>Remark is evaluated by GenAI.</span>
          </div> */}

          <div className="accept-popup__uploadfiles">
            Upload Files
            {props.isEvidenceRequired && (
              <span
                className="upload-required-indicator"
                role="img"
                aria-label={requiredFileLabel}
              >
                <Badge empty={true} color="red" />
              </span>
            )}
          </div>
          {isActionAlreadyCompleted && (
            <div className="accept-popup__uploadfilesnote">
              {ACTION_ALREADY_COMPLETED_UPLOAD_TEXT}
            </div>
          )}

          <div className="upload-wrapper_reasons">
            <FileUpload
              className="document-upload" // @ts-ignore
              anomaly_id={props.opportunityObjectName}
              opportunityId={props.opportunityId}
              type={uploadType}
              onUploadSuccess={props.onUploadSuccess}
              updateUploadedStatus={(uploaded: boolean) =>
                setIsUploaded(uploaded)
              }
            />
          </div>
          {isUploaded && (
            <div className="accept-popup__remarkerr">{FILE_UPLOAD_WARNING}</div>
          )}
          {uploadedFilesList}
        </Modal.Content>
      ) : showModal === "text" ? (
        <Modal.Content>
          <label className="label">
            {(props.action_for.includes("Yes") &&
              props.action_for.includes("No") &&
              props.action_for.includes("Maybe")) ||
            (props.action_for.includes("No") &&
              props.action_for.includes("Maybe"))
              ? "Explain Why"
              : "What data was collected and where?"}{" "}
            {props.remarks === "null" || props.remarks === "" ? (
              <Badge empty={true} color="red" />
            ) : (
              ""
            )}
          </label>
          <TextArea
            onChange={handleRemarkChange}
            className="textarea-wrapper-comment"
            fluid={true}
            rows={1}
            placeholder={props.textAreaTitle}
            value={props.remarks !== "null" ? props.remarks : ""}
          />
          <div className="accept-popup__uploadfiles">
            Upload Files
            {props.isEvidenceRequired && (
              <span
                className="upload-required-indicator"
                role="img"
                aria-label={requiredFileLabel}
              >
                <Badge empty={true} color="red" />
              </span>
            )}
          </div>
          {isActionAlreadyCompleted && (
            <div className="accept-popup__uploadfilesnote">
              {ACTION_ALREADY_COMPLETED_UPLOAD_TEXT}
            </div>
          )}
          <div className="upload-wrapper_reasons">
            <FileUpload
              className="document-upload" // @ts-ignore
              anomaly_id={props.opportunityObjectName}
              opportunityId={props.opportunityId}
              type={CHECKLIST_UPLOAD_TYPE}
              onUploadSuccess={props.onUploadSuccess}
              updateUploadedStatus={(uploaded: boolean) =>
                setIsUploaded(uploaded)
              }
            />
          </div>
          {isUploaded && (
            <div className="accept-popup__remarkerr">{FILE_UPLOAD_WARNING}</div>
          )}
          {uploadedFilesList}
        </Modal.Content>
      ) : (
        ""
      )}

      <Modal.Footer className="accept-popup__footer pop-footer">
        {showRemarkError && <div className="err-msg">{HAS_SCRIPT}</div>}
        {enableRetryErr && (
          <div className="accept-popup__footer--err err-msg">
            {ERROR_MSG_FOR_USER_RESPONSE}
          </div>
        )}
        <div className="action--error-text error-submit">
          {props.errorMessage}
        </div>
      </Modal.Footer>
    </div>
  );
};

export default RadioActionStatus;
